export default {
    API_BASE_URL: process.env.VUE_APP_API_HOST //'https://bord-booking.dk'
}